import React from "react";
import "../Banner/banner.css";

const Banner = () => {
  return (
    <>
      <section className="slider">
        <div className="video-banner">
          {/* Use HTML <video> tag to display the .webm video */}
          <video
            className="video-element" // Add a class for better control
           
            autoPlay // Automatically play the video
            loop // Loop the video
            muted // Mute the video by default
          >
            <source
              src="/assets/images/videoplayback.webm" // Path to your .webm file in the public folder
              type="video/webm"
            />
            Your browser does not support the video tag.
          </video>
          {/* <div className="slider_des">
            <h5 className="heading">
              JOURNEY TO <span>EXPLORE WORLD</span>
            </h5>
            <p className="sub_text">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s.
            </p>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default Banner;
